import config from "../../config";

export function setUser(state, user) {
  state.user = user;
}

// export function setViewAsUser(state, user) {
//   state.viewAs = user;
// }

export function setCurrentUser(state, user) {
  state.current_user = user;
}

export function setCurrentUserParents(state, data) {
  state.current_user_parents = data;
}

export function setSelectedUser(state, user) {
  state.selected_user = user;
}

export function usersError(state, payload) {
  state.error = true;
  state.errorMessage = payload;
  state.user = [];
}

export function setUserMessages(state, messages) {
  state.messages = messages;
}

export function setCompanyChart(state, payload) {
  state.companyChart = !state.companyChart
}

export function resetCompanyChart(state, payload) {
  state.companyChart = false
}

export function seeCompanyChart(state, payload) {
  state.companyChart = true
}